import React, { useEffect, useReducer } from 'react';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../utils/formUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { createGlobalDoorCamera } from '../../../utils/IntegrationsAPIUtils';
import {
  fetchAllGREGlobalConfigs,
  greGlobalDoorCameraSelector,
  vendorsSelector,
} from '../../../layouts/configurations/configurationSlice';
import CustomSelect from '../../../shared/form-controls/custom-select/Custom-Select';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceGlobalTabDoorCamera = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const greGlobalDoorCamera = useSelector(greGlobalDoorCameraSelector);
  const allVendors = useSelector(vendorsSelector);
  const { doorCamera } = allVendors;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    provider: {
      value: '',
      fieldName: 'Door Camera Provider',
      errors: {},
      validations: ['required'],
    },
    username: {
      value: '',
      fieldName: 'User Name',
      errors: {},
      validations: [],
    },
    password: {
      value: '',
      fieldName: 'Password',
      errors: {},
      validations: [],
    },
    ipAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: ['validIP'],
    },
    port: {
      value: '',
      fieldName: 'Port',
      errors: {},
      validations: [],
    },
  });

  useEffect(() => {
    if (greGlobalDoorCamera) {
      const currFields = { ...formData };
      for (let field in greGlobalDoorCamera) {
        if (currFields.hasOwnProperty(field)) {
          currFields[field].value = greGlobalDoorCamera[field];
        }
      }
      setFormData(currFields);
    }
  }, [greGlobalDoorCamera]);

  const validate = (isUpdatedFields) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isUpdatedFields ? updatedFields : isUpdatedFields);
    if (isUpdatedFields) setFormData(updatedFields);
    return isValid;
  };

  const onSubmitGlobalDoorCamera = async (e) => {
    try {
      e.preventDefault();
      dispatch(stepUpLoaderCount());

      if (!validate(true)) return false;
      const payload = {
        provider: formData.provider.value,
        username: formData.username.value,
        password: formData.password.value,
        ipAddress: formData.ipAddress.value,
        port: formData.port.value,
        hotelId: selectedHotel,
      };
      await createGlobalDoorCamera(payload);
      dispatch(fetchAllGREGlobalConfigs(selectedHotel));
      notificationManager('success', 'Door camera details updated successfully');
    } catch (error) {
      if (error?.message) {
        notificationManager('danger', error?.message);
      } else {
        notificationManager('danger', 'Unable to update door camera');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onChangeIP = (e) => {
    e.validations = e.value ? ['validIP'] : [];
    setFormData({ ipAddress: e });
  };
  return (
    <form className='global-tab-default' noValidate onSubmit={onSubmitGlobalDoorCamera}>
      <div className='container px-0 d-flex align-items-end flex-column h-100'>
        <div className='row w-100 d-flex mt-2'>
          <div className='d-flex flex-wrap col-12 row'>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomSelect
                item={formData.provider}
                handleInputChange={(e) => {
                  setFormData({ provider: e });
                }}
                options={doorCamera}
                labelField='name'
                valueField='id'
              />
            </div>
          </div>
          <div className='d-flex flex-wrap col-12 row'>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomTextField
                item={formData.username}
                handleInputChange={(e) => {
                  setFormData({ username: e });
                }}
              />
            </div>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomTextField
                item={formData.password}
                handleInputChange={(e) => {
                  setFormData({ password: e });
                }}
              />
            </div>
          </div>
          <div className='d-flex flex-wrap col-12 row'>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomTextField item={formData.ipAddress} handleInputChange={(e) => onChangeIP(e)} />
            </div>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomTextField
                item={formData.port}
                handleInputChange={(e) => {
                  setFormData({ port: e });
                }}
              />
            </div>
          </div>
        </div>
        <div className='row d-flex mt-auto w-100 pb-4'>
          <div>
            <Button
              size='large'
              variant='contained'
              color='primary'
              className='me-3'
              type='submit'
              disabled={!validate(false)}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceGlobalTabDoorCamera;
